export default __webpack_public_path__ + "static/media/to_delete7.79c4b85b.png";